import { render, staticRenderFns } from "./WebP.vue?vue&type=template&id=5445529a&"
import script from "./WebP.vue?vue&type=script&lang=ts&"
export * from "./WebP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports